import React from 'react';

interface ICircleSmall_15 {
  fill: string;
  id?: string;
}

const CircleSmall_15: React.FC<ICircleSmall_15> = ({ fill, id }) => {
  return (
  <svg width="228" height="228" viewBox="0 0 228 228" fill="none" xmlns="http://www.w3.org/2000/svg">
  <mask id="mask0_1825_1991" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="228" height="228">
  <circle cx="114" cy="114" r="114" fill={fill}/>
  </mask>
  <g mask="url(#mask0_1825_1991)">
  <rect y="-867" width="12" height="1961" fill={fill}/>
  <rect x="36" y="-867" width="12" height="1961" fill={fill}/>
  <rect x="72" y="-867" width="12" height="1961" fill={fill}/>
  <rect x="108" y="-867" width="12" height="1961" fill={fill}/>
  <rect x="144" y="-867" width="12" height="1961" fill={fill}/>
  <rect x="180" y="-867" width="12" height="1961" fill={fill}/>
  <rect x="216" y="-867" width="12" height="1961" fill={fill}/>
  </g>
  </svg>
  );
  };
  export default CircleSmall_15;
